import { ButtonNextStep, ButtonPrevStep } from '../../../../../components/buttons/ButtonNavigation';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import AccessRights from '../../../Company/Employees/AccessRightsSection/AccessRights';
import { STEPS_CONTRACTOR_CREATE, STEPS_CONTRACTOR_CREATE_NO_DETAILS } from '../../Model/Models';
import ContractorCompanyFields from './ContractorCompanyFields';
import ManagerFields from './ManagerFields';
import Summary from './Summary';
/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */

const ContractorCreateStepperWithoutDetails = ({
    user,
    setUser,
    steps,
    activeStep,
    setActiveStep,
    handleStepChange,
    emptyFields,
    resetForm,
    getAllServiceType,
    handleValidateSteps,
    isValidDocumentId,
    setIsValidDocumentId,
    isValidEmail,
    isValidPhoneNumber,
    isValidDob,
    setIsValidDob,
    handleEmailChange,
    handlePasswordChange,
    handlePhoneNumberChange,
    handleDateChange,
    userInfoStatusList,
    photoPicker,
    setPhotoPicker,
    disabled,
    workShiftsList,
    setWorkShiftsList,
    customizedList,
    setCustomizedList,
    validateEmail,
    validatePhone,
    FormHandler,
    extraDataEnabled,
    headersList,
    extraData,
}) => {
    return (
        <StepperTabs
            id={null}
            disabled={false}
            steps={steps}
            activeStep={activeStep}
            isStepOptional={() => {}}
            setActiveStep={setActiveStep}
            handleStepChange={handleStepChange}
        >
            <StepTab
                index={STEPS_CONTRACTOR_CREATE_NO_DETAILS.COMPANY_DETAILS}
                activeStep={activeStep}
                normalHeight={true}
            >
                <>
                    <ContractorCompanyFields
                        user={user}
                        setUser={setUser}
                        emptyFields={emptyFields}
                        resetForm={() => {
                            resetForm(activeStep);
                        }}
                        getAllServiceType={getAllServiceType}
                    />
                    <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6 mb-60px d-flex justify-content-end'>
                        <ButtonNextStep
                            id='btn_ccswd_next_company_fields'
                            text='next'
                            click={() => {
                                if (handleValidateSteps(activeStep)) {
                                    setActiveStep((prevStep) => prevStep + 1);
                                }
                            }}
                        />
                    </div>
                </>
            </StepTab>

            <StepTab
                index={STEPS_CONTRACTOR_CREATE_NO_DETAILS.MANAGER_DETAILS}
                activeStep={activeStep}
                normalHeight={true}
            >
                <>
                    <ManagerFields
                        title={'manager'}
                        user={user}
                        setUser={setUser}
                        emptyFields={emptyFields}
                        isValidDocumentId={isValidDocumentId}
                        setIsValidDocumentId={setIsValidDocumentId}
                        isValidEmail={isValidEmail}
                        isValidPhoneNumber={isValidPhoneNumber}
                        isValidDob={isValidDob}
                        setIsValidDob={setIsValidDob}
                        handleEmailChange={handleEmailChange}
                        handlePasswordChange={handlePasswordChange}
                        handlePhoneNumberChange={handlePhoneNumberChange}
                        handleDateChange={handleDateChange}
                        statusList={userInfoStatusList}
                        handleClearAll={() => {
                            resetForm(STEPS_CONTRACTOR_CREATE.MANAGER_DETAILS);
                        }}
                    />
                    <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                        <ButtonPrevStep
                            id='btn_ccswd_back_manage_fields'
                            text='back'
                            click={() => setActiveStep((prevStep) => prevStep - 1)}
                        />
                        <ButtonNextStep
                            id='btn_ccswd_next_manage_fields'
                            text='next'
                            disabled={activeStep === steps.length - 1}
                            click={() => {
                                if (handleValidateSteps(activeStep, true)) {
                                    setActiveStep((prevStep) => prevStep + 1);
                                }
                            }}
                        />
                    </div>
                </>
            </StepTab>

            <StepTab index={STEPS_CONTRACTOR_CREATE_NO_DETAILS.ADD_PHOTO} activeStep={activeStep} normalHeight={true}>
                <>
                    <CustomPhotoPicker
                        id='fp_ccswd_create_photo_profile'
                        photoPicker={photoPicker}
                        setPhotoPicker={setPhotoPicker}
                        actionModel={ACTION_MODEL.CREATE}
                        accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                        showBtnCamera={true}
                        validateFace={true}
                        classWith={'content-center-w-400px mt-4'}
                        showPreview={true}
                        disabled={disabled}
                        typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE}
                    />
                    <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                        <ButtonPrevStep
                            id='btn_ccswd_back_photo_picker'
                            text='back'
                            click={() => setActiveStep((prevStep) => prevStep - 1)}
                        />
                        <ButtonNextStep
                            id='btn_ccswd_next_photo_picker'
                            text='next'
                            disabled={activeStep === steps.length - 1}
                            click={() => {
                                setActiveStep((prevStep) => prevStep + 1);
                            }}
                        />
                    </div>
                </>
            </StepTab>

            <StepTab
                index={STEPS_CONTRACTOR_CREATE_NO_DETAILS.ACCESS_RIGHT}
                activeStep={activeStep}
                normalHeight={true}
            >
                <>
                    <AccessRights
                        workShiftsList={workShiftsList}
                        setWorkShiftsList={setWorkShiftsList}
                        customizedList={customizedList}
                        setCustomizedList={setCustomizedList}
                        user={user}
                        isEditable={true}
                        resetForm={() => {
                            resetForm(activeStep);
                        }}
                    />
                    <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                        <ButtonPrevStep
                            id='btn_ccswd_back_access_rights'
                            text='back'
                            click={() => setActiveStep((prevStep) => prevStep - 1)}
                        />
                        <ButtonNextStep
                            id='btn_ccswd_next_access_rights'
                            text='next'
                            disabled={activeStep === steps.length - 1}
                            click={() => {
                                setActiveStep((prevStep) => prevStep + 1);
                            }}
                        />
                    </div>
                </>
            </StepTab>

            <StepTab index={STEPS_CONTRACTOR_CREATE_NO_DETAILS.SUMMARY} activeStep={activeStep} normalHeight={true}>
                <>
                    <Summary
                        user={user}
                        workShiftsList={workShiftsList}
                        customizedList={customizedList}
                        photoPicker={photoPicker}
                        getAllServiceType={getAllServiceType}
                        extraDataEnabled={extraDataEnabled}
                        headersList={headersList}
                        extraData={extraData}
                    />
                    <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                        <ButtonPrevStep
                            id='btn_ccswd_back_summary'
                            text='back'
                            click={() => setActiveStep((prevStep) => prevStep - 1)}
                        />
                        <ButtonNextStep
                            id='btn_ccswd_enroll_contractor'
                            text='create'
                            click={() => {
                                validateEmail(user.email);
                                validatePhone(user.phoneNumber);
                                FormHandler();
                            }}
                        />
                    </div>
                </>
            </StepTab>
        </StepperTabs>
    );
};
export default ContractorCreateStepperWithoutDetails;
